<template>
	<div>
    <h5>{{ $t('Cambiar contraseña') }}</h5><br>
    <form method="post" v-on:submit.prevent="onSubmit">
      <div class="form-head fix">
        <div class="input-group">
          <div class="input-group-addon"><i class="fa fa-lock"></i></div>
            <input type="password" class="form-control" :placeholder="$t('Contraseña actual')" maxlength="150" required="" v-model="ContrasenaActual" autocomplete="on">
        </div>
        <div class="input-group">
          <div class="input-group-addon"><i class="fa fa-lock"></i></div>
            <input type="password" class="form-control" :placeholder="$t('Contraseña nueva')" maxlength="150" required="" v-model="ContrasenaNueva" autocomplete="off">
        </div> 
        <div class="input-group">
          <div class="input-group-addon"><i class="fa fa-lock"></i></div>
            <input type="password" class="form-control" :placeholder="$t('Confirmación contraseña')" maxlength="150" required="" v-model="ContrasenaConfirmacion" autocomplete="off">
        </div>              
      </div>

      <div class="comment center">{{ $t('La contraseña nueva debe tener una longitud mínima de 8 caracteres!') }}</div>

      <div v-if="loading" class="loading center"><img src="@/assets/img/loading.gif" alt=""></div>

      <div v-if="frm_success" class="frm-success">{{ frm_success_message }}</div>
      <div v-if="frm_error" class="frm-error">{{ frm_error_message }}</div>

      <div class="center">
        <button class="btn btn-tata mb40" type="submit" :disabled="loading">{{ $t('Actualizar contraseña') }} <i class="fa fa-angle-double-right"></i></button>
      </div>
    </form>
  </div>
</template>

<i18n>
{
  "es": {
    "Cambiar contraseña": "Cambiar contraseña",
    "Contraseña actual": "Contraseña actual",
    "Contraseña nueva": "Contraseña nueva",
    "Confirmación contraseña": "Confirmación contraseña",
    "Actualizar contraseña": "Actualizar contraseña",
    "La contraseña nueva debe tener una longitud mínima de 8 caracteres!": "La contraseña nueva debe tener una longitud mínima de 8 caracteres!"
  },
  "en": {
  },
  "ca": {
    "Cambiar contraseña": "Cambiar contrasenya",
    "Contraseña actual": "Contrasenya actual",
    "Contraseña nueva": "Contrasenya nova",
    "Confirmación contraseña": "Confirmació contrasenya",
    "Actualizar contraseña": "Actualitzar contrasenya",
    "La contraseña nueva debe tener una longitud mínima de 8 caracteres!": "La contrasenya nova ha de tenir com a mínim 8 caràcters!"
  }
}
</i18n>

<script>
  import axios from 'axios'; 
  import { mapGetters } from 'vuex';

	export default {
		data: () => {
			return{
        ContrasenaActual: '',
        ContrasenaNueva: '',
        ContrasenaConfirmacion: '',
        frm_response: '',
        frm_success: false,
        frm_success_message: '',
        frm_error: false,
        frm_error_message: '',
        loading: false
			}
		},
    computed: mapGetters(['getApiUrl', 'getLocale']), 
    methods: { 
      onSubmit(){
       if( this.ContrasenaNueva.length < 8 ){
          this.frm_error_message = this.$t('La contraseña nueva debe tener una longitud mínima de 8 caracteres!');
          this.frm_error = true;
        }else if( this.ContrasenaNueva != this.ContrasenaConfirmacion ){
          this.frm_error_message = this.$t('La contraseña nueva y la confirmación no coinciden!');
          this.frm_error = true;
        }else{

          this.frm_success = false;
          this.frm_error = false;
          this.showLoading();

          axios.post(this.getApiUrl + this.getLocale + '/cambiar-contrasena',{
            contrasena_actual:       this.ContrasenaActual,
            contrasena_nueva:     this.ContrasenaNueva,
            contrasena_confirmacion:    this.ContrasenaConfirmacion
          })
          .then( (response) => {
            this.hideLoading();
            this.frm_success_message = response.data.msg;
            this.frm_success = true;   
            this.clearFormData();
          })
          .catch( (error) => {
            this.frm_error_message = error.response.data.status + ' ' + error.response.data.msg;
            this.frm_error = true;
            this.hideLoading();
          });

        }
      },
      showLoading(){ this.loading = true; },
      hideLoading(){ this.loading = false; },
      clearFormState(){
        setTimeout( () => { 
          this.frm_success_message = "";
          this.frm_error_message = "";
          this.frm_success = false;
          this.frm_error = false;
        }, 3000);
      }
    },
    watch: {
    }
  }
</script>
